import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import './App.css';
import MainP from './page/'
import './css/myStyle.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import Colorhub from "./page/colorhub";
import DailySales from "./page/salenotify"
import Web333 from "./page/web333";
import Lebrandname from "./page/lebrandname";
import Zoolution from "./page/zoolution";
import Fireground from "./page/fireground";
import Mines789 from "./page/mines789";

function App() {
  return (
    <>
      <Router>
          <Routes>
            <Route path="/" element={<MainP />} />
            <Route path="/colorhub" element={<Colorhub />} />
            <Route path="/salenotify" element={<DailySales />} />
            <Route path="/web333" element={<Web333 />} />
            <Route path="/lebrandname" element={<Lebrandname />} />
            <Route path="/zoolution" element={<Zoolution />} />
            <Route path="/fireground" element={<Fireground />} />
            <Route path="/mines789" element={<Mines789 />} />
          </Routes>
      </Router>
    </>
  );
}

export default App;
